// extracted by mini-css-extract-plugin
module.exports =  {"leftAlign":"jMeHHUMw6vZNoAXNIYRp"};